import getIsTWAMode from './appMode_helper'
import { getTwaNotificationsEnabled } from './twaNotifications'

/**
 * Asks the native app to re-check the OS notification permission when the app returns to the foreground.
 *
 * The web can't read that permission itself in a TWA, so it hands the native side its current belief
 * (`enabled`) plus the page to come back to (`returnUrl`). The native `refresh-notifications` handler
 * relaunches the TWA — refreshing the `notificationsEnabled` launch param — ONLY if the permission
 * actually changed; otherwise it just returns to the tab (no reload). No-op outside the TWA.
 */
export default function refreshTwaNotificationState() {
  if (typeof window === 'undefined' || !getIsTWAMode()) return
  const enabled = getTwaNotificationsEnabled() // true | false | null
  const enabledParam = enabled === null ? 'unknown' : String(enabled)
  const returnUrl = encodeURIComponent(window.location.href)
  window.location.href = `togetherscheme://refresh-notifications?returnUrl=${returnUrl}&enabled=${enabledParam}`
}
